import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // URL 파라미터와 이동 훅
import { Navbar } from '../../../components/Navbar/Navbar';
import { Footer } from '../../../components/Footer/Footer';
import { Banner } from "../../../components/Banner/Banner";
import './NoticeDetail.css'; // 스타일 파일 (아래 2-1단계에서 만듦)

export const NoticeDetail = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    const { id } = useParams(); // URL에서 :id 부분을 가져옴
    const navigate = useNavigate();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                // 백엔드(5001번 포트)에 요청
                const response = await fetch(`${BOARD_URL}/posts/${id}`);
                
                if (!response.ok) {
                    throw new Error('게시물을 찾을 수 없습니다.');
                }
                const data = await response.json();
                setPost(data);
            } catch (error) {
                console.error(error);
                alert("게시물을 불러오지 못했습니다.");
                navigate('/notice'); // 에러나면 목록으로 돌려보냄
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [id, navigate]);

    if (loading) return <div>로딩 중...</div>;
    if (!post) return null;

    return (
        <>
            <Navbar />
            <Banner title="공지사항" />

            < div className="notice-detail-container">
         
                    <div className="notice-detail-header">
                        <h2 className="notice-detail-title">{post.title}</h2>
                        <div className="notice-detail-info">
                            <span className="date">작성일: {new Date(post.createdAt).toLocaleDateString()}</span>
                        </div>
                    </div>
                    
                    <div className="notice-detail-content">
                        {/* 줄바꿈 처리를 위해 pre-wrap 스타일 적용 */}
                        {post.content}
                    </div>

                    <div className="notice-detail-btn-wrap">
                        <button className="list-btn" onClick={() => navigate('/notice')}>
                            목록으로
                        </button>
                    </div>
        
            </div>

            <Footer />
        </>
    );
};